import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

const ReaderCompletionFormBadge = ({
  animateSlow = false,
  category,
  icon,
  size = 'large'
}: {
  animateSlow?: boolean;
  category: 'light' | 'success' | 'warning' | 'error';
  icon: IconProp;
  size?: 'small' | 'large';
}) => {
  const { theme } = useReduxState();

  const backgroundColor = {
    light: theme.lightGrey,
    success: theme.successLightColor,
    warning: theme.warningLightColor,
    error: theme.dangerLightColor
  }[category];

  const color = {
    light: theme.textColorLight,
    success: theme.successLightTextColor,
    warning: theme.warningLightTextColor,
    error: theme.dangerLightTextColor
  }[category];

  const fontSize = size === 'small' ? '2.4rem' : '4rem';

  const width = size === 'small' ? '54px' : '74px';

  return (
    <div className={`badge ${animateSlow ? 'slow' : 'fast'}`}>
      <div className="icon">
        <Icon icon={icon} />
      </div>

      <style jsx>{`
        @keyframes fadein {
          from {
            background-color: white;
            top: 20px;
          }
          to {
            background-color: ${backgroundColor};
            top: 0;
          }
        }
        @keyframes appear {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .badge {
          align-items: center;
          background-color: white;
          border-radius: 100px;
          display: inline-flex;
          font-size: ${fontSize};
          justify-content: center;
          position: relative;
          text-align: center;
          top: 20px;
          height: ${width};
          width: ${width};
        }
        .badge.slow {
          animation: fadein 1s ease-out 0s forwards;
        }
        .badge.fast {
          animation: appear 0.5s ease-out 0s forwards;
          background-color: ${backgroundColor};
          top: 0;
        }
        .icon {
          color: ${color};
          position: relative;
          opacity: 0;
        }
        .badge.slow .icon {
          animation: appear 2s ease-out 1s forwards;
        }
        .badge.fast .icon {
          animation: appear 0.5s ease-out 0s forwards;
        }
      `}</style>
    </div>
  );
};

export default ReaderCompletionFormBadge;
